module.exports = __webpack_public_path__ + "static/chart-customisation-072ea77c60362bd57b5770a1d1335118.png";